import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { generateMarketTrends } from '../../lib/openai';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiTrendingUp, FiLoader, FiCopy, FiCheck } = FiIcons;

function MarketTrends() {
  const [trends, setTrends] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [vehicleCategory, setVehicleCategory] = useState('SUV');
  const [region, setRegion] = useState('Northeast US');
  const [copied, setCopied] = useState(false);

  const generateTrends = async () => {
    setIsLoading(true);
    try {
      const result = await generateMarketTrends(vehicleCategory, region);
      setTrends(result);
    } catch (error) {
      console.error('Error generating market trends:', error);
      setTrends('Failed to generate market trends. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(trends);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <SafeIcon icon={FiTrendingUp} className="w-5 h-5 mr-2 text-primary-500" />
        Market Trends Analysis
      </h3>
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Vehicle Category
            </label>
            <select
              value={vehicleCategory}
              onChange={(e) => setVehicleCategory(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="SUV">SUV</option>
              <option value="Sedan">Sedan</option>
              <option value="Truck">Truck</option>
              <option value="Compact">Compact</option>
              <option value="Luxury">Luxury</option>
              <option value="Electric">Electric</option>
              <option value="Hybrid">Hybrid</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Region
            </label>
            <select
              value={region}
              onChange={(e) => setRegion(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="Northeast US">Northeast US</option>
              <option value="Southeast US">Southeast US</option>
              <option value="Midwest US">Midwest US</option>
              <option value="Southwest US">Southwest US</option>
              <option value="West Coast US">West Coast US</option>
              <option value="National US">National US</option>
            </select>
          </div>
        </div>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={generateTrends}
          disabled={isLoading}
          className="w-full bg-primary-600 text-white py-2 rounded-lg font-medium hover:bg-primary-700 transition-colors flex items-center justify-center space-x-2 disabled:opacity-50"
        >
          {isLoading ? (
            <>
              <SafeIcon icon={FiLoader} className="w-4 h-4 animate-spin" />
              <span>Analyzing...</span>
            </>
          ) : (
            <>
              <SafeIcon icon={FiTrendingUp} className="w-4 h-4" />
              <span>Generate Market Analysis</span>
            </>
          )}
        </motion.button>

        {trends && (
          <div className="mt-4 border border-gray-200 rounded-lg p-4 bg-gray-50 relative">
            <pre className="whitespace-pre-wrap text-sm font-sans">{trends}</pre>
            <button
              onClick={copyToClipboard}
              className="absolute top-2 right-2 p-2 text-gray-500 hover:text-primary-600 hover:bg-gray-100 rounded-full transition-colors"
              title="Copy to clipboard"
            >
              <SafeIcon
                icon={copied ? FiCheck : FiCopy}
                className={`w-4 h-4 ${copied ? 'text-green-500' : ''}`}
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default MarketTrends;